module.exports = "<mat-form-field>\n  <mat-select name=\"{{name}}\" placeholder=\"{{placeholder}}\" [ngModel]=\"value\" (ngModelChange)=\"change($event)\" [disabled]=\"readonly\">\n    <mat-option *ngFor=\"let item of lista\" [value]=\"item.value\">\n      {{ item.label }}\n    </mat-option>\n  </mat-select>\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-select/bra-select.component.html
// module id = ../../../../../src/app/componentes/bra-select/bra-select.component.html
// module chunks = main